import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

/**
 * Auth Pages
 */
import LoginPage from "../../Screens/Login/LoginPage";
import RegisterPage from '../../Screens/Register/RegisterPage';

const ToLogin = () => {
    return <Navigate to="/login" replace={true} />;
};

const AuthNavigation = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LoginPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="*" element={<ToLogin />} />
            </Routes>
        </BrowserRouter>
    );
};

export default AuthNavigation;
